/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import {useCallback, useState} from 'react';
import {useAgentsAPI} from './useAgentsAPI';
import {APIParams, METHODS} from '../../../hooks/abstractions/useTrusstedAgent';
import {AGENTS_API_EVENT_NAMES} from '../../../types/agents-api';

export const useGetAgentDocumentUploadUrl = () => {
  const agentsAPI = useAgentsAPI();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetch = useCallback(
    async (agentId: string, filename: string) => {
      setIsLoading(true);
      setError(null);

      try {
        const result: {url: string; filename: string} = await agentsAPI({
          eventName: AGENTS_API_EVENT_NAMES.GeneratePresignedPutUrl,
          methodName: METHODS.GET,
          params: {},
          queryParams: {agentId, filename},
        } as APIParams);
        setIsLoading(false);
        return result;
      } catch (err) {
        setError('Error generating upload URL');
        setIsLoading(false);
        return Promise.reject(err);
      }
    },
    [agentsAPI],
  );

  return {
    isLoading,
    error,
    fetch,
  };
};
